import { getHeaders } from './localStorage';
import axios from 'axios';
import { api, versao } from '../config';
import errorHandling from './errorHandling';
import moment from 'moment';
import { formatCPF } from '/';

import {
  GET_CLIENTE,
	GET_CLIENTES,
  GET_PRODUTOS,
  GET_UPSELLS,
  NEW_ORDER
} from './types';

export const getClientesPesquisa = (termo, loja) => {
	return function(dispatch){
  const encoded = encodeURIComponent(termo || '');
  axios.get(`${api}/${versao}/api/clientes/search/${encoded}?loja=${loja}`, getHeaders())
  .then(response => dispatch({ type: GET_CLIENTES, payload: response.data }))
  .catch(errorHandling);
	}
}

export const getProdutosPesquisa = (termo, loja) => {
  return function(dispatch){
    axios.get(`${api}/${versao}/api/produtos/search/${termo}?loja=${loja}`, getHeaders())
    .then(response => { console.log(response.data); dispatch({ type: GET_PRODUTOS, payload: response.data })})
    .catch(errorHandling);
  }
}

export const searchProdutoForWhatsApp = async (termo, loja) => {
  const name = (termo || '').trim().replace(/\s+/g, ' ');
  if (!name) return [];
  const response = await axios.get(
    `${api}/${versao}/api/produtos/search/${encodeURIComponent(name)}?loja=${loja}&exact=1`,
    getHeaders()
  );
  return response.data?.produtos?.docs || [];
}

export const getUpsellsPesquisa = (termo, loja) => {
  return function(dispatch){
    axios.get(`${api}/${versao}/api/upsell/search/${termo}?loja=${loja}`, getHeaders())
    .then(response => dispatch({ type: GET_UPSELLS, payload: response.data }))
    .catch(errorHandling);
  }
}

const parseMoneyInput = (raw) => {
  if (raw == null || raw === '') return 0;
  const s = String(raw).trim().replace(/\s/g, '');
  const normalized = s.includes(',') ? s.replace(/\./g, '').replace(',', '.') : s;
  const n = parseFloat(normalized);
  return Number.isFinite(n) ? n : 0;
};

export const newOrderManual = ({ form, client, cart, cartUpsell }, cb) => {
  return function(dispatch){

    const cartItems = cart?.items || [];
    const upsells = (cartUpsell?.items ? cartUpsell.items : []) || [];

    const goodsTotal = Number((cart?.total || 0) + (cartUpsell?.total || 0));
    const deliveryNum = parseMoneyInput(form.deliveryValue);
    const discountNum = Math.max(0, parseMoneyInput(form.orderDiscount));
    const totalDue = Math.max(0, goodsTotal + deliveryNum - discountNum);

    const carrinho = [...cartItems, ...upsells]
      .filter(item => item && item._id)
      .map(item => ({
        produto: item._id,
        quantidade: item.quantity,
        precoUnitario: item.price,
        upsell: item.type && item.type === "upsell" ? item._id : null
      }));


    const data = {
      client,
      loja: client.loja,
      observation: form.observation,
      erpVendedorId: form.vendedorId || null,
      carrinho,
      entrega: {
        custo: deliveryNum,
        tipo: "manual",
        prazo: form.deliveryDate,
        endereco: {
          local: form.deliveryStreet,
          numero: form.deliveryNumber,
          complemento: form.deliveryComplement,
          bairro: form.deliveryNeighbor,
          cidade: "Rio de Janeiro",
          estado: "RJ",
          CEP: "22795-171",
          pais: "Brasil"
        },
        shippingValue: deliveryNum,
        shippingDate: moment(form.deliveryDate).format('DD/MM/YYYY') || "Não informado",
        shippingPeriod: form.deliveryPeriod || "Não informado",
        shippingSender: form.senderAnon === "Anônimo" ? "Anônimo" : form.senderShipping,
        shippingRecipient: form.senderReciever,
        shippingMessageSelect: (form.messageCard || '').length > 0 ? true : false,
        shippingMessage: (form.messageCard || '').length > 0 ? (form.messageCard || '') : ""
      },
      pagamento: {
        valor: totalDue,
        valueCart: totalDue,
        forma: "manual",
        parcelas: 1,
        enderecoEntregaIgualCobranca: false,
        // endereco: {
        //   local: "manual",
        //   numero: "manual",
        //   complemento: "manual",
        //   bairro: "manual",
        //   cidade: "manual",
        //   estado: "manual",
        //   CEP: "manual",
        //   pais: "manual"
        // },
        cartao: undefined
      }
    };

    if (discountNum > 0) {
      data.coupon = { code: 'MANUAL', value: discountNum };
    }

    axios.post(`${api}/${versao}/api/pedidos/admin?loja=${client.loja}`, data, getHeaders())
    .then(response => {
      dispatch({ type: NEW_ORDER, payload: response.data });
      dispatch(cb(response.data));
    })
    .catch(e => cb(errorHandling(e)));
  }
};

export const findClienteByEmailOrCpf = (email, cpf, loja) => {
  const params = new URLSearchParams({ loja });
  if (email && email.trim()) params.set('email', email.trim());
  if (cpf && cpf.trim()) params.set('cpf', cpf.trim());
  if (!params.get('email') && !params.get('cpf')) return Promise.resolve(null);
  return axios.get(`${api}/${versao}/api/clientes/find?${params}`, getHeaders())
    .then(response => response.data?.cliente || null);
};

export const updateClienteCpf = (cliente, cpf, loja) => {
  if (!cpf || !cliente?._id) return Promise.resolve();
  const digits = String(cpf).replace(/\D/g, '');
  if (digits.length < 11) return Promise.resolve();
  const _cpf = digits.length <= 11 ? formatCPF(cpf) : cpf;
  const body = {
    nome: cliente.nome || '',
    email: cliente.email || '',
    cpf: _cpf,
    telefones: cliente.telefones || []
  };
  return axios.put(`${api}/${versao}/api/clientes/admin/${cliente._id}?loja=${loja}`, body, getHeaders())
    .then(res => res.data?.cliente || { ...cliente, cpf: _cpf })
    .catch(() => cliente);
};

export const createNewCliente = (form, loja, cb) => {
  const rawCpf = (form.clientCpf || '').trim().replace(/\D/g, '');
  const _cpf = rawCpf.length >= 11 ? formatCPF(form.clientCpf) : (form.clientCpf || '');
  return function(dispatch){
    axios.post(`${api}/${versao}/api/clientes/manual?loja=${loja}`, { nome: form.clientName, email: form.clientEmail, cpf: _cpf, telefones: [ form.clientPhone ] }, getHeaders())
    .then(response => {
      dispatch({ type: GET_CLIENTE, payload: response.data })
      cb(null, response.data)
    })
    .catch(e => cb(e));
  }
}